module.exports = __webpack_public_path__ + "img/personal.26221341.jpg";